// extracted by mini-css-extract-plugin
export const form = "editProfile-module--form--qG7XM";
export const input = "editProfile-module--input--EWEtW";
export const errorMsg = "editProfile-module--errorMsg--BRFYq";
export const btnUpdate = "editProfile-module--btnUpdate--LQ6RP";
export const title = "editProfile-module--title--ci9fG";
export const profileSection = "editProfile-module--profileSection--zgqzC";
export const passwordTitle = "editProfile-module--passwordTitle--h+z+a";
export const cropper = "editProfile-module--cropper--HTJFb";